<template>
  <div class="flex items-center">
    <div
      v-for="(item, idx) in items"
      :key="`radio-item-${idx}-${item.id}`"
      class="flex items-center"
    >
      <input
        :id="`radio-${item.value}-${idx}`"
        v-model="radioVal"
        :value="item.value"
        :disabled="props.disabled"
        type="radio"
        class="hidden h-4 w-4 text-cdp-main-primary accent-cdp-main-primary"
      />
      <button @click="selected(item)">
        <icon
          v-show="radioVal === item.value && !props.disabled"
          name="ic_radio_on_normal"
          class="h-6 w-6 text-cdp-main-primary"
        />
        <icon
          v-show="radioVal !== item.value && !props.disabled"
          name="ic_radio_off_normal"
          class="h-6 w-6 text-cdp-grey-400"
        />
        <icon
          v-show="radioVal === item.value && props.disabled"
          name="ic_radio_on_disable"
          class="h-6 w-6 text-cdp-black-200"
        />
        <icon
          v-show="radioVal !== item.value && props.disabled"
          name="ic_radio_off_disable"
          class="h-6 w-6 text-cdp-black-200"
        />
      </button>
      <label
        :for="`radio-${item.value}-${idx}`"
        class="mx-2 text-sm font-normal text-cdp-black-500"
      >
        <slot :key="`slotIdx-${idx}`" name="text" :item="item">
          {{ item.text }}
        </slot>
      </label>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   *
   * 備註：radioGroup 註冊名稱為 radio
   */
  name: 'Radio',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    items: {
      type: Array,
      default: () => [
        {
          text: String,
          value: Number
        }
      ]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const radioVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
      }
    });

    function selected(item) {
      if (props.disabled) return false;
      radioVal.value = item.value;
      emit('change', radioVal.value);
    }

    return {
      props,
      radioVal,
      selected
    };
  }
});
</script>